import { atom } from 'recoil'

const taskInitAtom = atom({
	key: 'taskInitAtom',
	default: false,
})

const taskDetailAtom = atom({
	key: 'taskDetailAtom',
	default: false,
})

const meshProfileAtom = atom({
	key: 'meshProfileAtom',
	default: false,
})

const chatHistoryAtom = atom({
	key: 'chatHistoryAtom',
	default: {},
})

const chatGuessAtom = atom({
	key: 'chatGuessAtom',
	default: [],
})

const promptAtom = atom({
	key: 'promptAtom',
	default: '',
})

const stopChatAtom = atom({
	key: 'stopChatAtom',
	default: false,
})

const assistantChatStatusAtom = atom({
	key: 'assistantChatStatusAtom',
	default: '',
})
const guessChatStatusAtom = atom({
	key: 'guessChatStatusAtom',
	default: '',
})

const chatTextAtom = atom({
	key: 'chatTextAtom',
	default: '',
})

const chatLangAtom = atom({
	key: 'chatLangAtom',
	default: 'Chinese',
})

const generateProgressAtom = atom({
	key: 'generateProgressAtom',
	default: {},
})


const needStartWsAtom = atom({
	key: 'needStartWsAtom',
	default: false,
})

const chatDialogStartAtom = atom({
	key: 'chatDialogStartAtom',
	default: false,
})

const generateStageAtom = atom({
	key: 'generateStageAtom',
	default: 'generate',
})

const taskCandidateAtom = atom({
	key: 'taskCandidateAtom',
	default: [],
})

const modelSelectedAtom = atom({
	default: false,
	key: 'modelSelected',
})

export const modelHideAtom = atom({
	default: false,
	key: 'modelHide',
})

export const currentCardsAtom = atom({
	default: 'ImagineFace',
	key: 'currentCards',
})

export const imgurlsAtom = atom({
	default: false,
	key: 'imgurls',
})

export const taskidAtom = atom({
	default: false,
	key: 'taskid',
})

export const generateprocessAtom = atom({
	default: false,
	key: 'generateprocess',
})

export const generatestateAtom = atom({
	default: false,
	key: 'generatestate',
})

export const inputSizeAtom = atom({
	default: false,
	key: 'inputSize',
})

export const timeAtom = atom({
	default: 0,
	key: 'time',
})

export const generateurlsAtom = atom({
	default: [],
	key: 'generateurls',
})

export const imgCardAtom = atom({
	default: false,
	key: 'imgCard',
})

export const isUploadingAtom = atom({
	default: false,
	key: 'isUploading',
})

export const imgfileAtom = atom({
	default: '',
	key: 'imgfile',
})

export const generatedAtom  = atom({
	default: false,
	key: 'generated',
})

export const generatingAtom = atom({
	default: false,
	key: 'generatingAtom',
})



export {
	taskInitAtom,
	taskDetailAtom,
	chatHistoryAtom,
	chatGuessAtom,
	promptAtom,
	stopChatAtom,
	meshProfileAtom,
	assistantChatStatusAtom,
	guessChatStatusAtom,
	chatTextAtom,
	chatLangAtom,
	generateProgressAtom,
	needStartWsAtom,
	chatDialogStartAtom,
	generateStageAtom,
	taskCandidateAtom,
	modelSelectedAtom,
}
